import {Component} from 'react';
import {ModelAides,getDroitsAvailable,traitementAidesCategories} from './lib/droits.js';
import {DroitCell} from './droit-cell';
import Espacemembre from './espacemembre';
import AidesVelo from './aidesvelo';
import analytics from '../../services/analytics';

class Resultats extends Component {

	constructor(props){
		super(props);
		this.state = {
			results: {},
			droitsBeneficiable :[],
			aidesParCategories :{},
			loading: true,
            more:true,
			categoriesClass :{
				"Aide(s) Juridique": "aides-juridiques",
				"Aide(s) au logement": "aides-logement",
				"Aide(s) aux loisirs": "aides-loisirs",
				"Aide(s) aux transports": "aides-transports",
				"Aide(s) à l'insertion professionnelle": "aides-professionnelle",
				"Aide(s) à la santé": "aides-sante",
			}

		}

		var entities = {};
		Object.keys(ModelAides).forEach( (droit)=>{
			entities[droit.entity]= null;
		});

        entities = { ...entities , ...this.props };

        entities.demandeur.rfr = null;
        // test rfr
        if ( entities.conjoint && Object.keys(entities.conjoint).length > 0 ) {
            entities.famille.parents = ['individu', 'conjoint'];
            entities.menage.conjoint = ['conjoint'];
            entities.foyer_fiscal.declarants =['individu', 'conjoint'];
        }

        entities.foyer_fiscal.personnes_a_charge=[];
        entities.menage.enfants=[];
        entities.famille.enfants=[];
        entities.menage.cheque_energie = null;


        Object.keys(entities.individus).forEach ((individu)=>{
            if ( individu !== 'demandeur' && individu !== 'conjoint' ) {
                entities.foyer_fiscal.personnes_a_charge.push(individu);
                entities.menage.enfants.push(individu);
                entities.famille.enfants.push(individu);
            }
        });
        /* Variable logement conventionne menage */
        entities.menage.logement_conventionne =
          entities.menage.statut_occupation_logement &&
          entities.menage.statut_occupation_logement === 'primo_accedant' &&
          entities.menage.loyer &&
          entities.menage.loyer === 0;



        /* mettre les infos velo dans un state et enlever des entities parce que ca polue les infos.*/
            const prixVelo = entities.demandeur.prixVelo;
            const typeVelo = entities.demandeur.typeVelo;
            const regionCode = entities.menage.regionCode;
            const codePostal = entities.menage.code_postal;
            const codeEpci = entities.menage.codeEpci;
            const codeInsee = entities.menage.depcom;
            const siren = entities.menage.siren;
            const nom =  entities.menage.nomVille;
           // const rfrParPart = entities.demandeur.rfrParPart //a remplacer par rfr de openfisca en post traitement


        delete entities.demandeur.date_fin_contrat;
        //entities.foyer_fiscal.rfr = null;
        if ( typeof entities.conjoint !== 'undefined' ){
            entities.conjoint.statut_marital = entities.demandeur.statut_marital;
        }
        
        const requestURI = "https://simulateurs.aide-sociale.fr/simulateur-backend-test/of.php" ; //openfisca
        const requestAS = "https://simulateurs.aide-sociale.fr/simulateur-backend-test/as.php"; //aide-sociale API
        
        var data = {
            'individus':  {
                ...entities.individus
                ,...{
                    'individu' : entities.demandeur,
                    'conjoint' : entities.conjoint,
                }
            },
            'familles' : {
                _ : entities.famille,
            },
            'foyers_fiscaux' : {
                _ : entities.foyer_fiscal,
            },
            'menages': {
                _ : entities.menage,
            }
        };



        data.menages._.aide_logement_date_pret_conventionne = (new Date().getFullYear() - 4).toString() + '-12-31';

        this.state.recap_situation = data;
        this.state.unparsedData = {
            individus :{
                ...entities.individus
                ,...{
                    'individu' : entities.demandeur,
                    'conjoint' : entities.conjoint,
                }
            },
            famille : entities.famille,
            foyer_fiscal : entities.foyer_fiscal,
            menage : entities.menage

        };
        if ( entities.demandeur.nationalite === undefined ) {
            this.state.unparsedData.individus.individu.nationalite = 'FR';
        }
        if ( this.state.unparsedData.menage.statut_occupation_logement === undefined) {
            this.state.unparsedData.menage.statut_occupation_logement = 'sans_domicile';
        }

        Object.keys(data).forEach( (entity)=>{
            data[entity] = JSON.stringify(data[entity]);
        });

        const request = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },

            body:JSON.stringify(data)
        };

        fetch(requestURI ,request)
            .then((res)=> {
                return res.json();
            })
            .then ((json)=>{
                this.state.results = json;
                var definedRessources = [];
                if ( typeof this.props.definedRessources !== 'undefined' && this.props.definedRessources !== null){
                    (Object.keys(this.props.definedRessources).forEach((i)=>{return definedRessources.push(this.props.definedRessources[i]);}));
                }
                this.state.droitsBeneficiable = getDroitsAvailable(this.state.results.openfisca,definedRessources);
                //this.state.aidesParCategories = traitementAidesCategories(JSON.parse(this.state.results.as_api));

                /* post-traitement openfisca this.state.results.openfisca ; */
                let current_year  = new Date().getFullYear();


                let rfr = 0;
                if(this.state.results?.openfisca?.foyer_fiscaux !== undefined){
                    rfr = this.state.results.openfisca.foyers_fiscaux._.rfr[current_year];
                }

                this.state.d = {
                "velo" : {
                    "type" : typeVelo,
                    "price" : prixVelo,
                },
                    "localite" : nom,
                    "codeInsee" : codeInsee,
                    "nom" : nom,
                    "codeEpci" : codeEpci ,
                    "siren" : siren ,
                    "region": regionCode,
                    "rfr" : rfr,
                    "codePostal" : entities.menage.code_postal
                }
                //console.clear();

                //this.saveResultEspaceMembre();
                this.setState( {loading:false});
            });

        fetch(requestAS ,request)
            .then((res)=> {
                return res.json();
            })
            .then ((json)=>{
                this.state.results = json;
                var definedRessources = [];
                if ( typeof this.props.definedRessources !== 'undefined' && this.props.definedRessources !== null){
                    (Object.keys(this.props.definedRessources).forEach((i)=>{return definedRessources.push(this.props.definedRessources[i]);}));
                }

                this.state.aidesParCategories = traitementAidesCategories(JSON.parse(this.state.results.as_api));

                //console.clear();
                this.saveResultEspaceMembre();
                this.setState( {loading:false});
                this.setState( {more:false});

                // Tracker la fin de session avec le nombre total d'aides éligibles
                const totalBenefits = this.state.droitsBeneficiable.length +
                    Object.values(this.state.aidesParCategories).reduce((sum, cat) => sum + cat.length, 0);
                analytics.trackSessionComplete(totalBenefits);
            });



    }

    saveResultEspaceMembre = () => {
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let email = window.email;
        let situationIdRemote = window.situationId;
        let isMember = email && situationIdRemote;
        if ( isMember ) {

            // Preparing  data for requset .
            const data_api ={
                'id': situationIdRemote,
                'email': email ,
                'droits':  JSON.stringify(this.parseDataDroitsEspaceMembre()),
                'aide_soc_json' : this.state.results.as_api,
                'situation' : JSON.stringify(this.state.unparsedData),
            };

            // Preparing request .
            const request = {
                    method:'POST',
                    headers: {
                      'Content-Type' : 'Application/json',
                    },
                    body: JSON.stringify(data_api),
            };

            const saveResult = "https://aide-sociale.fr/espacemembre/public/api/save-result" ;
            // Send data for current user.
            fetch( saveResult , request)
              .then((res)=>{
                  console.log(res);
              }).catch((err) => {
                console.error(err);
              });
        }
    }

    parseDataDroitsEspaceMembre = () => {
        let dataDroits = {};
        this.state.droitsBeneficiable.forEach( (droit)=> {

            dataDroits[droit.nom] = droit;
            dataDroits[droit.nom].image = "./assets/img/"+ droit.imgSrc;
            dataDroits[droit.nom].isbool = droit.type === "boolean";
            dataDroits[droit.nom].unit = droit.unit === undefined ? '€' :droit.unit;
        });
        return [dataDroits];
    }

    connect = (email , password) => {
        const connectionUrl = 'https://aide-sociale.fr/espacemembre/public/loginfromoutside';


        fetch("https://aide-sociale.fr/espacemembre/public/token")
            .then( (res)=>{
                return res.body.getReader().read()

            })
            .then( (uint8array)=> {
                let decoder = new TextDecoder();
                let token = decoder.decode(uint8array.value);

                const data = {
                    "email" : email ,
                    "password":password,
                    "droits":JSON.stringify(this.parseDataDroitsEspaceMembre()),
                    "aide_soc_json": this.state.results.as_api,
                    "situation" : JSON.stringify(this.state.unparsedData),
                    "_token" : token,
                };

                const request = {
                    method:'POST',
                    headers: {
                      'Content-Type' : 'Application/json',
                        'X-CSRF-TOKEN': token
                    },
                    body: JSON.stringify(data),
                };

                let loginUrl = "https://aide-sociale.fr/espacemembre/public/loginfromoutside?password="+password+'&email='+email;
                window.open(loginUrl , '_blank');

                fetch(connectionUrl , request)
                    .then((response)=>{
                        return response.body.getReader().read();
                    })
                    .then( (uint8array) =>{
                        return new TextDecoder().decode(uint8array.value);
                    })
                    .then( (res)=>{
                        let message = JSON.parse(res);

                        if (typeof message.error !== 'undefined' ){
                            this.setState( {feedbackEspacemembre : message.error});
                        } else {
                            this.setState( {
                                feedbackEspacemembre : <p>Si vous n'avez pas été redirigé automatiquement veuillez cliquer <a href="https://aide-sociale.fr/espacemembre/public/result">ici</a></p>
                            });
                        }
                    })
                    .catch( (response)=>{
                        console.error(response);
                          var loginErrors = <p>Si vous n'avez pas été redirigé automatiquement veuillez cliquer <a href="https://aide-sociale.fr/espacemembre/public/result" target="_blank"  rel="noreferrer" >ici</a></p>;
                          if ( response.status === 422 ) {
                              data = response.body.getReader.read()
                                  .then((res)=>{
                                      return JSON.parse( new TextDecoder().decode(res.value));
                                  });
                              loginErrors = data.errors;
                          }
                          else if (response.status === 419){
                            if ( response.data.message === "CSRF token mismatch.") {
                               loginErrors = " Vous êtes deja connecter";
                            }
                          }
                          /* Internal Server Error*/
                          else if ( response.status === 500 ){
                             loginErrors = 'Une Erreur est survenu lors de la géstion de votre requete';
                          }
                          this.setState({feedbackEspacemembre: {message :loginErrors}});
                    });
            });
    }

    subscribe = (email) => {
        const subscribeUrl= "https://aide-sociale.fr/espacemembre/public/api/register-optin-user";

        const data = {
            "email" : email ,
            "droits": JSON.stringify(this.parseDataDroitsEspaceMembre()),
            "aide_soc_json": this.state.results.as_api,
            "situation" : JSON.stringify(this.state.unparsedData)
        };

        const request = {
            method: 'POST',
            headers: {
              'Content-Type': 'Application/json',
            },
            body:JSON.stringify(data),
        };


        this.setState({feedbackEspacemembre:{load:true}});



        fetch(subscribeUrl ,request)
            .then((response)=>{
                return response.body.getReader().read();
            })
            .then( (uint8array) =>{
                return new TextDecoder().decode(uint8array.value);
            })
            .then( (res)=>{
                let message = JSON.parse(res);

                if (typeof message.error !== 'undefined' ){
                    this.setState( {feedbackEspacemembre : {error: true , message : message.error}});
                } else {
                    this.setState(
                    {feedbackEspacemembre :
                      {
                        error: false,
                        message : "Un e-mail vous a été envoyé avec un lien pour vous connecter à votre espace membre.",

                      }
                    });


					// Sendinblue
					fetch ( 'https://www.aide-sociale.fr/simulateur/stats-report.php' ,
						{
					        "method":'POST',
					        "body": JSON.stringify(data)
				     	}
				    );
				}
			})
			.catch((error)=>{
				console.error(error);
			});
	}

    restart = ()=>{
        this.props.restart();
    }

    support = (email) => {
        /*Envoyer les resultats par email */
        const supportUrl = "https://aide-sociale.fr/support/support-save.php";
        const data = {
            "email" : email ,
            "droits": JSON.stringify(this.parseDataDroitsEspaceMembre()),
            "aide_soc_json": this.state.results.as_api
        };

        const request = {
            method: 'POST',
            mode:'no-cors',
            headers: {
              'Content-Type': 'Application/json',
            },
            body:JSON.stringify(data),
        };

        fetch(supportUrl ,request)
            .then((response) => {
                console.log("Sent");
        });
    }

    recoveryPassword = (email) => {

        /* Envoyer email avec auto login a l'espace membre directement avec les resultats a jours */
        const supportUrl = "https://aide-sociale.fr/support/setupautologin.php"; //API
        const data = {
            "email" : email ,
            "droits": JSON.stringify(this.parseDataDroitsEspaceMembre()),
            "aide_soc_json": this.state.results.as_api
        };

        const request = {
            method: 'POST',
            mode:'no-cors',
            headers: {
              'Content-Type': 'Application/json',
            },
            body:JSON.stringify(data),
        };

        fetch(supportUrl ,request)
            .then((response) => {
            console.log("sent");
        });
        this.setState({ feedbackEspacemembre: undefined });


    }

    removefeedback = () => {
        this.setState({ feedbackEspacemembre: undefined });
    }

    // Helper method to calculate end time based on start time
    calculateEndTime = (startTime) => {
        if (!startTime) return '';
        const [hours, minutes] = startTime.split(':').map(Number);
        // Assuming 2-hour time slots as per the reduction-eligibility.js file
        const endHour = hours + 2;
        return `${endHour.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    }

    // Helper method to calculate end time based on start time for 4-hour slots
    calculateEndFourHourTime = (startTime) => {
        if (!startTime) return '';
        const [hours, minutes] = startTime.split(':').map(Number);
        // 4-hour time slots for 'open' meeting option
        const endHour = hours + 4;
        return `${endHour.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    }

    // Method to send data to aide-sante.com endpoint
    sendLeadData = (reductionData) => {
        // Extract the meeting date and time from the meeting field
        let meetingDateTime = '';
        if (reductionData.meeting && reductionData.meeting !== '') {
            const date = reductionData.meeting.substring(0, 10);
            const time = reductionData.time_slot_start || reductionData.meeting.substring(11, 16) || '';
            meetingDateTime = time ? `${date} ${time}` : date;
        }

        const leadData = {
            "choix": reductionData.selectedOption,
            "meeting": meetingDateTime,
            "nom": reductionData.lastName || '',
            "prenom": reductionData.firstName || '',
            "email": reductionData.email || '',
            "telephone": reductionData.phoneNumber || '',
            "codepostal": this.props.menage?.code_postal || '',
            "ville": this.props.menage?.nomVille || '',
            "logement": this.props.menage?.statut_occupation_logement || ''
        };

        // Only send the request if choix is not null/undefined
        if (leadData.choix !== undefined && leadData.choix !== null) {
            fetch('https://www.aide-sante.com/simulateur/insertlead.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(leadData)
            })
            .then(response => {
                console.log('Lead data sent successfully:', response.status);
                return response.text();
            })
            .then(data => {
                console.log('Lead data response:', data);
            })
            .catch(error => {
                console.error('Error sending lead data:', error);
            });
        }
    }

    // Flag to track if sendLeadData has already been called
    hasSentLeadData = false;

    componentDidMount() {
        // Send lead data when component mounts if data exists
        if (this.props.menage?.reductionEligibilityData && !this.hasSentLeadData) {
            this.sendLeadData(this.props.menage.reductionEligibilityData);
            this.hasSentLeadData = true;
        }
    }

    componentDidUpdate(prevProps) {
        // Send lead data only when the reduction eligibility data first becomes available
        const currentReductionData = this.props.menage?.reductionEligibilityData;
        const prevReductionData = prevProps.menage?.reductionEligibilityData;

        // Only send data if current data exists, it was not available before, and we haven't sent it yet
        if (currentReductionData && !prevReductionData && !this.hasSentLeadData) {
            //this.sendLeadData(currentReductionData);
            this.hasSentLeadData = true;
        }
    }


    render(){

        var i = 0;
        const currentYear = new Date().getFullYear();
        const [anneeN2 , anneeN1] = [currentYear-2 , currentYear-1];
        const isActif  = this.props.demandeur.activite === "actif";

		return <div className="step-inner-container">

			{ ( this.state.loading ) ?
				<>
				  <div className="loader"></div>
				  <p className="text-center">Chargement des résultats...</p>
				</>
				: <div className="resultats">
					<Espacemembre
						connect={this.connect}
						subscribe={this.subscribe}
						feedback={this.state.feedbackEspacemembre}
                        support={this.support}
                        recoveryPassword = {this.recoveryPassword}
                        removefeedback={this.removefeedback}

					/>
					<div className="notice">
						<p>Nous avons supposé que vos ressources pour l'année {anneeN2} étaient les mêmes qu'entre décembre {anneeN1} et décembre {currentYear}.</p>
						<button onClick={this.props.validateStep}>Déclarer vos ressources {anneeN2}</button>
					</div>
					<div className="information">
					  <p>Selon les renseignements que vous avez saisis, vous êtes, a priori en situation de bénéficier des aides suivantes.
					  Les montants ne sont donnés qu’à titre indicatif et sont arrondis.</p>
					</div>
					<div className="categorie aides-principaux">
					  <h4>Aides principales</h4>
					  {this.state.droitsBeneficiable.map( ( droit)=>(
					  	  (droit.nom === "garantie_jeunes" && isActif) ? '' : <DroitCell model={droit} localImg={true} key={i++} />
					  	)
					  )}
					</div>
					<hr className="droit-separation"/>
                    {(this.state.more) &&
                         <>
                          <div className="loader"></div>
                          <p className="text-center">Résultats supplémentaires...</p>
                        </>
                    }


				{ Object.keys(this.state.aidesParCategories).map( (categorie)=>(
					<>
					 <div className="categorie">
						<h4>{categorie}</h4>
						{this.state.aidesParCategories[categorie].map( (droit)=>(
							<DroitCell model={droit} key={i++} categorie={this.state.categoriesClass[categorie]}/>
						))}
					</div>
					<hr className="droit-separation"/>
                    {
                        (categorie === "Aide(s) aux transports") ?
                        <AidesVelo  d={this.state.d}/>  : ''
                    }
					</>
				))}

    				<div className="result-button button-container previous">
    						<button onClick={this.restart}> Recommencer </button>
    				</div>

                {/* Processing reductionEligibilityData after rendering to ensure all data is fully available */}
                {(() => {
                    if (this.props.menage?.reductionEligibilityData) {
                        const reductionData = this.props.menage.reductionEligibilityData;

                        // Only send data to papernest webhook if user did not select "no"
                        if (reductionData.selectedOption !== 'no') {
                            const cityName = this.props.menage?.nomVille || '';
                            const postalCode = this.props.menage?.code_postal || '';

                            // Format according to papernest.json structure
                            const papernestData = {
                                lead: {
                                    first_name: reductionData.firstName || '',
                                    last_name: reductionData.lastName || '',
                                    email: reductionData.email || '',
                                    phone_number: reductionData.phoneNumber ?
                                        (reductionData.phoneNumber.startsWith('0033') ?
                                         reductionData.phoneNumber :
                                         '0033' + reductionData.phoneNumber.replace(/^0/, '')) : '',
                                    language: 'fr',
                                    birth_country: '',
                                    birth_department: '',
                                    civility: 'mister',
                                    need_type: this.props.demandeur?.changementLogementRecent ? 'mover' : 'switcher',
                                    has_called_opt_in: true,
                                    source2: reductionData.selectedOption === 'oui' ? 'Rappel immédiat' : 'Rappel programmé',
                                    real_estate_agent_comments: this.props.demandeur ?
                                        Object.keys(this.props.demandeur)
                                            .filter(key => ['etudiant', 'retraite', 'chomeur', 'handicap', 'inapte_travail', 'enceinte', 'aucune_situations'].includes(key) && this.props.demandeur[key] === true)
                                            .map(key => key.replace('_', ' '))
                                            .join(', ') : '',
                                    prospect_comments : 'simulateur_globale'
                                },
                                callback: {
                                    country_code: "FRA",
                                    date: reductionData.selectedOption === 'oui' ?
                                         new Date().toISOString().substring(0, 10) :
                                         (reductionData.meeting === 'open' ?
                                          new Date().toISOString().substring(0, 10) :
                                          (reductionData.meeting && reductionData.meeting !== 'open' ?
                                           reductionData.meeting.substring(0, 10) : '')),
                                    time_slot_start: reductionData.selectedOption === 'oui' ?
                                                      new Date().toTimeString().substring(0, 5) :
                                                      (reductionData.meeting === 'open' ?
                                                       new Date().toTimeString().substring(0, 5) :
                                                       (reductionData.meeting && reductionData.meeting !== 'open' ?
                                                        reductionData.meeting.substring(11, 16) : '')),
                                    time_slot_end: reductionData.selectedOption === 'oui' ?
                                               this.calculateEndTime(new Date().toTimeString().substring(0, 5)) :
                                               (reductionData.meeting === 'open' ?
                                                this.calculateEndFourHourTime(new Date().toTimeString().substring(0, 5)) :
                                                (reductionData.meeting && reductionData.meeting !== 'open' ?
                                                 this.calculateEndTime(reductionData.meeting.substring(11, 16)) : ''))

                                },
                                housing: {

                                    address: {
                                        city: cityName,
                                        zip_code: postalCode,
                                        street: '',
                                        street_number: ''
                                    },
                                    house_type: this.props.menage.statut_occupation_logement || ''
                                }
                            };

                            console.log(JSON.stringify(papernestData));


                            //Send data to papernest webhook
                            fetch('https://hook.eu1.make.celonis.com/b03hhd1x9mottaasjxcuwgffofqkct2r', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify(papernestData)
                            })
                            .then(response => {
                                console.log('Webhook response status:', response.status);
                                return response.text();
                            })
                            .then(data => {
                                console.log('Webhook response data:', data);
                            })
                            .catch(error => {
                                console.error('Webhook error:', error);
                            });


                        }
                    }
                    return null;
                })()}

                </div>}
        </div>
    }
}


export default Resultats;
